export const API = {
  subcategories: {
    path: '/sub-categories',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
  },
  subcategory: {
    path: '/sub-categories/{{id}}',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
  },
  create: {
    path: '/sub-categories',
    method: 'POST',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => ({
      data: {
        ...body,
        area: body?.area?.id,
        location: body?.location?.toUpperCase(),
        marina: body?.marina?.toUpperCase(),
        code: body?.code,
      },
    }),
  },
  update: {
    path: '/sub-categories/{{id}}',
    method: 'PUT',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => ({
      data: {
        ...body,
      },
    }),
  },
  delete: {
    path: '/sub-categories/{{id}}',
    method: 'DELETE',
    get: null,
    auth: true,
    fallback: null,
  },
  select: {
    path: '/sub-categories?pagination[page]=1&pagination[pageSize]=1000',
    method: 'GET',
    get: 'data',
    auth: true,
    fallback: [],
    transform: (data) =>
      data.map((item) => ({
        name: item.attributes.name,
        id: item.id,
      })),
  },
};
